<template>
    <div class="p-10 mb-10 bg-mimer-gray flex flex-col items-center text-sm md:text-base">
        <b>Hur bor du idag?</b>
        <div class="sm:w-1/2 lg:w-1/3">
            <p>Innan du kan anmäla intresse behöver vi veta hur du bor idag.</p>
            <div class="grid grid-cols-1 gap-4">
                <div>
                    <label for="housingType" class="block uppercase text-sm font-bold mb-2"
                        >Nuvarande boendeform *</label
                    >
                    <span>
                        <select
                            name="nuvarande boendeform"
                            v-model="currentApplicantProfile.housingType"
                            id="housingType"
                            class="bg-white appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 untouched pristine required">
                            <option value="null">Välj nuvarande boendeform</option>
                            <option v-for="option in getHousingOptions()" :key="option.value" :value="option.value">
                                {{ getHousingTypeText(option.value) }}
                            </option>
                        </select>
                        <div
                            v-if="v$.currentApplicantProfile.housingType.$error"
                            style="color: #e3205e"
                            class="text-red text-sm italic pb-2 h-6">
                            <div>
                                <span>Fyll i Nuvarande boendeform</span>
                            </div>
                        </div>
                    </span>
                </div>
                <div
                    v-if="
                        currentApplicantProfile.housingType === 'RENTAL' ||
                        currentApplicantProfile.housingType === 'SUB_RENTAL'
                    ">
                    <label for="landlord" class="block uppercase text-sm font-bold mb-2">Nuvarande hyresvärd *</label>
                    <span>
                        <input
                            placeholder="Nuvarande hyresvärd"
                            name="nuvarande hyresvärd"
                            v-model="currentApplicantProfile.landlord"
                            id="landlord"
                            type="text"
                            class="bg-white appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 untouched pristine required" />
                        <div
                            v-if="v$.currentApplicantProfile.landlord.$error"
                            style="color: #e3205e"
                            class="text-red text-sm italic pb-2 h-6">
                            <span>Fyll i Nuvarande hyresvärd</span>
                        </div>
                    </span>
                </div>

                <div
                    v-if="
                        currentApplicantProfile.housingType === 'RENTAL' ||
                        currentApplicantProfile.housingType === 'SUB_RENTAL'
                    ">
                    <label for="landlordPhone" class="block uppercase text-sm font-bold mb-2"
                        >Telefonnummer hyresvärd *</label
                    >
                    <span>
                        <input
                            placeholder="Telefonnummer hyresvärd"
                            name="telefonnummer hyresvärd"
                            v-model="currentApplicantProfile.housingReference.landlordPhone"
                            id="landlordPhone"
                            type="tel"
                            class="bg-white appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 untouched pristine required" />
                        <div
                            v-if="v$.currentApplicantProfile.housingReference.landlordPhone.$error"
                            style="color: #e3205e"
                            class="text-red text-sm italic pb-2 h-6">
                            <span>Fyll i Telefonnummer hyresvärd</span>
                        </div>
                    </span>
                </div>

                <div
                    v-if="
                        currentApplicantProfile.housingType === 'RENTAL' ||
                        currentApplicantProfile.housingType === 'SUB_RENTAL'
                    ">
                    <label for="landlordEmail" class="block uppercase text-sm font-bold mb-2"
                        >Mejladress hyresvärd</label
                    >
                    <span>
                        <input
                            placeholder="Mejladress hyresvärd"
                            name="mejladress hyresvärd"
                            v-model="currentApplicantProfile.housingReference.landlordEmail"
                            id="landlordEmail"
                            type="email"
                            class="bg-white appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 untouched pristine required" />
                    </span>
                </div>

                <div v-if="currentApplicantProfile.housingType === 'OTHER'">
                    <label for="otherHousingDescription" class="block uppercase text-sm font-bold mb-2"
                        >Beskriv boendeform *</label
                    >
                    <span>
                        <input
                            placeholder="Beskriv boendeform"
                            name="beskriv boendeform"
                            v-model="currentApplicantProfile.otherHousingDescription"
                            id="otherHousingDescription"
                            type="text"
                            class="bg-white appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 untouched pristine required"
                            required />
                        <div
                            v-if="v$.currentApplicantProfile.otherHousingDescription.$error"
                            style="color: #e3205e"
                            class="text-red text-sm italic pb-2 h-6">
                            <span>Fyll i Beskriv boendeform</span>
                        </div>
                    </span>
                </div>

                <div v-if="currentApplicantProfile.housingType === 'OTHER'">
                    <label for="otherHousingPhone" class="block uppercase text-sm font-bold mb-2">Telefonnummer</label>
                    <span>
                        <input
                            placeholder="Telefonnummer"
                            name="telefonnummer"
                            v-model="currentApplicantProfile.housingReference.otherHousingPhone"
                            id="otherHousingPhone"
                            type="tel"
                            class="bg-white appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 untouched pristine" />
                    </span>
                </div>

                <div v-if="currentApplicantProfile.housingType === 'OTHER'">
                    <label for="otherHousingEmail" class="block uppercase text-sm font-bold mb-2">Mejladress</label>
                    <span>
                        <input
                            placeholder="Mejladress"
                            name="mejladress"
                            v-model="currentApplicantProfile.housingReference.otherHousingEmail"
                            id="otherHousingEmail"
                            type="email"
                            class="bg-white appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 untouched pristine" />
                    </span>
                </div>
            </div>
            <div class="pt-2">
                <p v-if="getNumberOfPreviousHouseholdMembers() > 0">
                    Du har tidigare angett att ni är
                    {{ convertToNumeral(getNumberOfPreviousHouseholdMembers()) }}
                    ({{ getNumberOfPreviousHouseholdMembers() }})
                    {{ getNumberOfPreviousHouseholdMembers() == 1 ? 'person' : 'personer' }} i hushållet. Stämmer det
                    för din ansökan?
                </p>
                <div v-if="previousAdultCount > 0" class="flex pb-4">
                    <div class="w-1/4">
                        <input type="radio" id="1" value="1" name="householdCount" v-model="householdCount" />
                        <label for="1" class="px-2">Ja</label>
                    </div>
                    <div class="w-1/4">
                        <input type="radio" id="0" value="0" name="householdCount" v-model="householdCount" />
                        <label for="0" class="px-2">Nej</label>
                    </div>
                </div>
                <div v-if="v$.householdCount.$error" style="color: #e3205e" class="text-red text-sm italic pb-2 h-6">
                    <span>Du måste välja ett alternativ</span>
                </div>
                <div v-if="householdCount === '0'" class="flex pb-4 -mx-2">
                    <div class="w-1/2 px-2">
                        <label for="adults" class="block uppercase text-sm font-bold mb-2">Antal vuxna *</label>
                        <input
                            placeholder="0"
                            id="adults"
                            v-model="currentApplicantProfile.numberOfAdults"
                            type="number"
                            min="1"
                            onkeydown="if(event.key==='.' || event.key===','){event.preventDefault();}"
                            class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 untouched pristine required" />
                        <div
                            v-if="v$.currentApplicantProfile.numberOfAdults.$error"
                            style="color: #e3205e"
                            class="text-red text-sm italic pb-2 h-6">
                            Fyll i Antal vuxna
                        </div>
                    </div>
                    <div class="w-1/2 px-2">
                        <label for="children" class="block uppercase text-sm font-bold mb-2">Antal barn *</label>
                        <input
                            placeholder="0"
                            id="children"
                            v-model="currentApplicantProfile.numberOfChildren"
                            type="number"
                            min="0"
                            onkeydown="if(event.key==='.' || event.key===','){event.preventDefault();}"
                            class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 untouched pristine required" />
                        <div
                            v-if="v$.currentApplicantProfile.numberOfChildren.$error"
                            style="color: #e3205e"
                            class="text-red text-sm italic pb-2 h-6">
                            Fyll i Antal barn
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-center pt-4">
                <div v-if="isLoading" class="mimer-button relative" style="width: 125px; height: 60px">
                    <img src="../../assets/3-dots-scale-white-36.svg" class="absolute w-full top-0 left-0 h-full" />
                </div>
                <div class="w-1/2" v-else>
                    <mimer-button @click="saveApplicationProfile()" text="Anmäl intresse" />
                </div>
            </div>
            <div class="flex items-center justify-center pt-2">
                <p class="italic">Vi sparar dina uppgifter på Min Profil</p>
            </div>
            <div v-if="errorMessage" class="flex items-center justify-center pt-4">
                <p class="italic pl-2">
                    {{ errorMessage }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { loggedInStatus } from '../../utils/helpers';
import { MimerButton } from 'mimer-components';
import { getHousingTypeText, getHousingOptions } from '@/utils/helpers';
import useValidate from '@vuelidate/core';
import { required, requiredIf, minLength, minValue } from '@vuelidate/validators';

export default {
    name: 'SupplyApplicationProfile',

    emits: ['onProfileFetched', 'onProfileSaved'],
    components: {
        MimerButton,
    },
    data() {
        return {
            v$: useValidate(),
            isLoading: false,
            currentApplicantProfile: {
                numberOfAdults: 0,
                numberOfChildren: 0,
                housingType: '',
                landlord: '',
                otherHousingDescription: '',
                housingReference: {
                    landlordPhone: '',
                    landlordEmail: '',
                    otherHousingPhone: '',
                    otherHousingEmail: '',
                },
            },
            previousAdultCount: 0,
            previousChildCount: 0,
            householdCount: null,
            errorMessage: '',
        };
    },
    validations() {
        return {
            currentApplicantProfile: {
                numberOfAdults: {
                    required,
                    minValue: minValue(1),
                },
                numberOfChildren: {
                    required,
                    minValue: minValue(0),
                },
                housingType: {
                    required,
                },
                landlord: {
                    required: requiredIf(function () {
                        return (
                            this.currentApplicantProfile.housingType === 'RENTAL' ||
                            this.currentApplicantProfile.housingType === 'SUB_RENTAL'
                        );
                    }),
                },
                otherHousingDescription: {
                    required: requiredIf(function () {
                        return this.currentApplicantProfile.housingType === 'OTHER';
                    }),
                },
                housingReference: {
                    landlordPhone: {
                        required: requiredIf(function () {
                            return (
                                this.currentApplicantProfile.housingType === 'RENTAL' ||
                                this.currentApplicantProfile.housingType === 'SUB_RENTAL'
                            );
                        }),
                        Length: minLength(7),
                    },
                },
            },
            householdCount: { required },
        };
    },
    methods: {
        getHousingOptions,
        getHousingTypeText,
        async saveApplicationProfile() {
            this.v$.currentApplicantProfile.$touch(); // Update validation status
            this.v$.householdCount.$touch();

            if (this.v$.currentApplicantProfile.$invalid || this.v$.householdCount.$invalid) {
                //validation failed, error msgs will be shown
                return false;
            }

            this.isLoading = true;

            try {
                let response = await axios.post(
                    process.env.VUE_APP_API_URL + '/api/applicants/me/applicantProfile',
                    this.currentApplicantProfile,
                    {
                        headers: {
                            Authorization: `Bearer ${loggedInStatus()}`,
                        },
                    }
                );

                if (response.status === 200) {
                    this.errorMessage = '';
                    this.isLoading = false;
                    this.$emit('onProfileSaved');
                    return;
                }
            } catch (err) {
                console.error('Failed to save the application profile: ', err);
            }
            this.isLoading = false;
            this.errorMessage = 'Något gick fel när din boendeprofil skulle sparas, vänligen försök igen.';
            return;
        },
        async fetchApplicantProfile() {
            try {
                let profileResp = await axios.get(process.env.VUE_APP_API_URL + '/api/applicants/me/applicantProfile', {
                    headers: {
                        Authorization: `Bearer ${loggedInStatus()}`,
                    },
                });
                if (profileResp.status == 204) {
                    //no applicant profile found. User must supply the profile
                    this.$emit('onProfileFetched', true);
                    this.householdCount = '0';
                    return;
                }

                if (profileResp.data && profileResp.data != '') {
                    //application profile found
                    this.currentApplicantProfile = profileResp.data;

                    this.previousAdultCount = this.currentApplicantProfile.numberOfAdults;
                    this.previousChildCount = this.currentApplicantProfile.numberOfChildren;
                }

                this.$emit('onProfileFetched', this.currentApplicantProfile.shouldProvideNewDetails);
            } catch (ex) {
                console.error('Failed to fetch the application profile: ', ex);
            }
        },
        convertToNumeral(m) {
            var numbers = [
                'noll',
                'en',
                'två',
                'tre',
                'fyra',
                'fem',
                'sex',
                'sju',
                'åtta',
                'nio',
                'tio',
                'elva',
                'tolv',
                'tretton',
                'fjorton',
                'femton',
                'sexton',
                'sjutton',
                'arton',
                'nitton',
                'tjugo',
            ];
            return numbers[m];
        },
        getNumberOfPreviousHouseholdMembers() {
            return this.previousAdultCount + this.previousChildCount;
        },
    },
    async mounted() {
        await this.fetchApplicantProfile();
    },
};
</script>
